import {getTenant} from "../helpers";
import {isJSON} from "@iblai/ibl-web-react-common";

export const createProgram = (data, callback) => {
    const url = process.env.REACT_APP_IBL_DM_URL + `/api/catalog/programs/`
    fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Token ' + localStorage.getItem('axd_token'),
        },
    }).then((resp)=>{
        callback(resp.ok);
    }).catch(()=>callback(false));
}

export const deleteProgram = (programID, callback) => {
    const currentTenant = localStorage.getItem("current_tenant")
    const platformOrg = isJSON(currentTenant) ? JSON.parse(currentTenant)?.org : null
    const baseURL = process.env.REACT_APP_IBL_STUDIO_URL
    const url =  `${String(baseURL).endsWith("/") ? baseURL : baseURL+"/"}api/ibl/manage/program/delete/`
    fetch(url, {
        method: 'POST',
        body:JSON.stringify({
            program_id:programID,
            org:platformOrg
        }),
        headers: {
            'Content-Type': 'application/json',
            //Authorization: 'Token ' + localStorage.getItem('axd_token'),
        },
        credentials:'include'
    }).then((resp)=>{
        callback(resp.ok);
    }).catch(()=>callback(false));
}

